<template>
  <div class="dealers-container">
    <div class="dealers-header-pc">
        <div class="dealers-header-title">
            以下是为您查询到的经销商信息，您还可以点击右侧按钮了解更多:
        </div>
        <div class="dealers-header-buttons">
            <div class="dealers-header-button btn-dark" @click="goLink('testDrive')" code-stm="event, PAGEURL, question-3-经销商类型-点击‘预约试驾’按钮">预约试驾</div>
            <div class="dealers-header-button btn-light" @click="goLink('dealer')"  code-stm="event, PAGEURL, question-3-经销商类型-点击‘经销商查询’按钮">经销商查询</div>
        </div>
    </div>
    <div class="dealers-header-mob">以下是为您查询到的经销商信息</div>
    <div class="dealers-grid-wrapper">
      <div class="dealers-grid-container">
        <div class="dealers-grid">
          <div 
            v-for="(dealer, index) in dealers" 
            :key="index" 
            class="dealer-card"
            @click="handleDealerClick(dealer)"
          >
            <div class="dealer-distance">距您 {{ dealer.distance }} km</div>
            <div class="dealer-tag">{{ dealer.typename }}</div>
            <div class="dealer-name">{{ dealer.name }}</div>
            <div class="dealer-address">{{ dealer.address }}</div>
            <div class="dealer-phone" v-if="dealer.saletel">
              <span class="phone-label">经销热线：</span>
              <span class="phone-number clickable" @click="makePhoneCall(dealer.saletel)">{{ dealer.saletel }}</span>
            </div>
            <div class="dealer-service" v-if="dealer.servicetel">
              <span class="phone-label">服务热线：</span>
              <span class="phone-number clickable" @click="makePhoneCall(dealer.servicetel)">{{ dealer.servicetel }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isPortraitFun, getUrlKey } from "@/utils/utils.js";
import { aiUrl } from "@/config/base";
export default {
  name: 'Dealers',
  props: {
    question: {
      type: Object,
      // default: {province: '北京市', city: '北京市'}
      default: {province: '辽宁省', city: '大连市'}
    },
    clientPosition: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dealers: [],
      isPortrait: isPortraitFun(),
      dealerUrl: '',
      testDriveUrl: '',
      token: '',
    }
  },
  created() {
    const userInfo = localStorage.getItem('user');
    var token=''
    if(userInfo){
      this.userInfo = JSON.parse(userInfo)
      token = this.userInfo.token
    }
    this.token = token

    this.initDealerUrl();
    this.initTestDriveUrl();
  },
  watch: {
    question: {
      immediate: true,
      handler(newVal) {
        const lng = this.clientPosition && this.clientPosition.lng != null ? this.clientPosition.lng : '';
        const lat = this.clientPosition && this.clientPosition.lat != null ? this.clientPosition.lat : '';

        this.fetchDealers(newVal, lng, lat);
      }
    },
    clientPosition: {
      immediate: true,
      handler() {
        // 定位更新后，带经纬度重新请求经销商数据，并更新距离
        const lng = this.clientPosition && this.clientPosition.lng != null ? this.clientPosition.lng : '';
        const lat = this.clientPosition && this.clientPosition.lat != null ? this.clientPosition.lat : '';
        if (lng != null && lat != null) {
          this.fetchDealers(this.question, lng, lat);
        } else {
          this.computeDistanceForDealers();
        }
      }
    }
  },
  methods: {
    async fetchDealers(q, lng, lat) {
      const that = this;
      this.dealers = [];
      this.$axios
        .post(
          `${aiUrl}keyword/searchDealer`,
          { 
            province: q.province, 
            city: q.city,
            lng: lng,
            lat: lat
          },
          // { province: '上海市', city: '上海市'},
          {
            headers: {
              token: that.token,
            },
          }
        )
        .then((res) => {
          const response = res.data || res;
          if (response.code == 200) {
            this.dealers = response.data;
            this.computeDistanceForDealers();
          }
        })
    },
    initDealerUrl() {
      const href = window.location.href || '';
      if (href.includes('uat.kia.cn')) {
        this.dealerUrl = 'https://uat.kia.cn/dealer/';
      } else if (href.includes('www.kia.cn') || href.includes('kia.cn')) {
        this.dealerUrl = 'https://www.kia.cn/dealer/';
      } else {
        this.dealerUrl = 'https://uat.kia.cn/dealer/';
      }
    },
    initTestDriveUrl() {
      const href = window.location.href || '';
      if (href.includes('uat.kia.cn')) {
        this.testDriveUrl = 'https://uat.kia.cn/test-drive/';
      } else if (href.includes('www.kia.cn') || href.includes('kia.cn')) {
        this.testDriveUrl = 'https://www.kia.cn/test-drive/';
      } else {
        this.testDriveUrl = 'https://uat.kia.cn/test-drive/';
      }
    },
    makePhoneCall(phoneNumber) { 
       _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), 'question-3-经销商类型-点击‘拨打电话’，电话号码'+ phoneNumber, 1]);
      stm_clicki("send",'event',window.location.href, "点击", 'question-3-经销商类型-点击‘拨打电话’，电话号码'+ phoneNumber);
      if (!phoneNumber) return;
      
      // 直接拨打电话（PC端和移动端都使用tel协议）
      window.location.href = `tel:${phoneNumber}`;
    },
    goLink(link) {
      const a = document.createElement('a');
      if (link === 'testDrive') {
        a.href = this.testDriveUrl;
      } else if (link === 'dealer') {
        a.href = this.dealerUrl;
      }
      a.target = '_blank';
      a.rel = 'noopener';
      a.click();
    },
    getTypeRank(typename) {
      const order = ['4S店', '1S店', '二级服务店'];
      const name = (typename || '').trim();
      const idx = order.indexOf(name);
      return idx === -1 ? order.length : idx;
    },
    computeDistanceForDealers() {
      if (!Array.isArray(this.dealers) || !this.dealers.length) return;
      const hasPos = this.clientPosition && this.clientPosition.lng != null && this.clientPosition.lat != null;
      const lng = hasPos ? parseFloat(this.clientPosition.lng) : null;
      const lat = hasPos ? parseFloat(this.clientPosition.lat) : null;
      this.dealers = this.dealers.map(d => {
        // 注意：后端字段“latitude”为经度(lng)，“longitude”为纬度(lat)
        const dLng = d && d.latitude != null ? parseFloat(d.latitude) : null;   // 经度
        const dLat = d && d.longitude != null ? parseFloat(d.longitude) : null; // 纬度
        let distance = '-';
        if (hasPos && !isNaN(dLat) && !isNaN(dLng)) {
          distance = this.haversineDistance(lat, lng, dLat, dLng);
        }
        return { ...d, distance };
      });
      // 先按门店类型优先级排序：4S店 > 1S店 > 二级服务店 > 其他；再按距离升序（无法计算距离的排在最后）
      const toNumberOrInfinity = (val) => {
        const n = parseFloat(val);
        return isNaN(n) ? Infinity : n;
      };
      this.dealers.sort((a, b) => {
        const rankA = this.getTypeRank(a.typename);
        const rankB = this.getTypeRank(b.typename);
        if (rankA !== rankB) return rankA - rankB;
        return toNumberOrInfinity(a.distance) - toNumberOrInfinity(b.distance);
      });
    },
    haversineDistance(lat1, lng1, lat2, lng2) {
      function toRad(deg) { return deg * Math.PI / 180; }
      if ([lat1, lng1, lat2, lng2].some(v => v == null || isNaN(v))) return '-';
      const R = 6371; // km
      const dLat = toRad(lat2 - lat1);
      const dLng = toRad(lng2 - lng1);
      const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
                Math.sin(dLng/2) * Math.sin(dLng/2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      const d = R * c;
      return d.toFixed(2);
    }
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 767px) {
  .dealers-header-mob {
    display: none;
  }
  .dealers-container {
      width: 100%;
      height: 100%;
      //   padding: calc(20 / 1080 * 100vh) calc(20 / 1920 * 100vw);
      background-color:#F3F4F7;//  rgba(6, 20, 31, 1);
    
    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 4px;
    }
    
    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.05);
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 3px;
      transition: background 0.3s ease;
      
      &:hover {
        background: rgba(0, 0, 0, 0.4);
      }
    }
    
    /* Firefox 滚动条样式 */
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);
    }
    
    
    
    .dealers-header-pc {
    // height: calc(80 / 1920 * 100vw);
    height: 57px;
    display: flex;
    align-items: center; 
    justify-content: space-between;
    padding: 0 calc(35 / 1920 * 100vw);
    background-color:#F3F4F7;// rgba(6, 20, 31, 1);
    .dealers-header-title {
      // font-size: calc(16 / 1920 * 100vw);
      font-size: 12px;
       color: #06141F;//rgba(155, 161, 165, 1);
      font-family: 'FZLanTingHeiS-R-GB'; 
    }
    .dealers-header-buttons {
      display: flex;
      align-items: center;
      justify-content: center;  
    }
    .dealers-header-button {
      // font-size: calc(12 / 1920 * 100vw);
      font-size: 11px;
      // margin-left: calc(6 / 1920 * 100vw);
      // width: calc(140 / 1920 * 100vw);
      // height:calc(46 / 1920 * 100vw); 
      margin-left: 6px;
      width: 120px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: calc(6 / 1920 * 100vw);
      cursor: pointer;
    }
    .btn-light {
      background-color: #fff;
      border: 1px solid rgba(6, 20, 31, 1);
      color: #333;
    }
    .btn-light:hover {
      background-color: rgba(6, 20, 31, 1);
      color: #fff;
      // border: 1px solid #fff;
      border: 1px solid rgba(6, 20, 31, 1);
    }
    .btn-dark {
      background-color: rgba(6, 20, 31, 1);
      color: #fff;
      border: 1px solid rgba(6, 20, 31, 1);
    }
    .btn-dark:hover {
      background-color: #fff;
      color: rgba(6, 20, 31, 1);
    }
  }
  .dealers-grid-wrapper {
    border-radius: calc(12 / 1920 * 100vw) calc(12 / 1920 * 100vw) 0 0;
    overflow: hidden;
  }
  .dealers-grid-container {
      overflow-y: auto;
      // height: calc(100vh - 78px - 40 / 1920 * 100vw - 80 / 1920 * 100vw);
      height: calc(100vh - 78px - 40 / 1920 * 100vw - 57px);
      background-color: #fff;
          /* 自定义滚动条样式 */
      &::-webkit-scrollbar {
        width: 4px;
        background-color: transparent;
      }
      
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      
      &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 2px;
        transition: background 0.3s ease;
        
        &:hover {
          background: rgba(0, 0, 0, 0.4);
        }
      }
      
      /* Firefox 滚动条样式 */
      scrollbar-width: thin;
      scrollbar-color: rgba(0, 0, 0, 0.2) #fff;
  }
  .dealers-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: calc(16 / 1920 * 100vw);
    align-items: start;
    padding: calc(50 / 1920 * 100vw);
    
    background-color: #fff;

    
  }

  .dealer-card {
    background-color: rgba(195, 204, 214, 0.2);
    border-radius: calc(7 / 1920 * 100vw);
    padding: calc(28 / 1920 * 100vw) calc(50 / 1920 * 100vw);
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    position: relative;
    
    /* 保持 600:231 的宽高比 */
    // aspect-ratio: 600 / 231;
    height: calc(231 / 1920 * 100vw);
    
    &:hover {
      background-color: rgba(195, 204, 214, 0.5);
      // transform: translateY(-2px);
      // box-shadow: 0 calc(4 / 1080 * 100vh) calc(12 / 1080 * 100vh) rgba(0, 0, 0, 0.1);
    }
  }

  .dealer-distance {
    position: absolute;
    top: calc(25  / 1920 * 100vw);
    right: calc(10 / 1920 * 100vw);
    padding: calc(4 / 1920 * 100vw) calc(10 / 1920 * 100vw);
    color: rgba(0, 0, 0, 0.8);
    font-size: calc(12 / 1920 * 100vw);
    font-family: 'FZLanTingHeiS-R-GB';
  }

  .dealer-tag {
    background-color: rgba(55, 67, 76, 0.1);
    font-size: calc(12 / 1920 * 100vw);
    font-family: 'FZLanTingHeiS-R-GB';
    padding: calc(4 / 1920 * 100vw) calc(8 / 1920 * 100vw);
    border-radius: calc(4 / 1920 * 100vw);
    margin-bottom: calc(8 / 1920 * 100vw);
  }

  .dealer-name {
    font-size: calc(20 / 1920 * 100vw);
    margin-bottom: calc(6 / 1920 * 100vw);
    font-family: 'FZLanTingHeiS-DB-GB';
    margin-bottom: calc(20 / 1920 * 100vw);
  }

  .dealer-address {
    font-size: calc(15 / 1920 * 100vw);
    line-height: calc(34 / 1920 * 100vw);
    font-family: 'FZLanTingHeiS-R-GB';
  }

  .dealer-phone,
  .dealer-service {
    line-height: calc(34 / 1920 * 100vw);
    font-size: calc(15 / 1920 * 100vw);
    font-family: 'FZLanTingHeiS-R-GB';
    display: flex;
    align-items: center;
    width: 100%;
  }

  .phone-label {
    margin-right: calc(4 / 1920 * 100vw);
    white-space: nowrap;
  }

  .phone-number {
    text-decoration: underline;
  }

}
@media (max-width: 767px) {
  .dealers-container {
    width: 100%;
    height: 100%;
    // background-color: rgba(6, 20, 31, 1);
    /* 自定义滚动条样式 */
    // &::-webkit-scrollbar {
    //   width: calc(4 / 375 * 100vw);
    // }
    // &::-webkit-scrollbar-track {
    //   background: rgba(0, 0, 0, 0.05);
    //   border-radius: calc(3 / 375 * 100vw);
    // }
    // &::-webkit-scrollbar-thumb {
    //   background: rgba(0, 0, 0, 0.2);
    //   border-radius: calc(3 / 375 * 100vw);
    //   transition: background 0.3s ease;
    //   &:hover {
    //     background: rgba(0, 0, 0, 0.4);
    //   }
    // }
    /* Firefox 滚动条样式 */
    // scrollbar-width: thin;
    // scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);
  }

  .dealers-header-pc {
    display: none;
  }

  .dealers-header-mob {
    display: flex;
    align-items: center;
    height: calc(46 / 375 * 100vw);
    // padding: 0 calc(16 / 375 * 100vw);
    // background-color: rgba(6, 20, 31, 1);
    font-size: calc(16 / 375 * 100vw);
    font-family: 'FZLanTingHeiS-B-GB';
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dealers-grid-wrapper {
    // border-radius: calc(12 / 375 * 100vw) calc(12 / 375 * 100vw) 0 0;
    overflow: hidden;
  }

  .dealers-grid-container {
    overflow-y: auto;
    height: calc(100vh - 46px);
    min-height: calc(100vh - 46px);
    /* 移动端兼容性优化 */
    height: calc(100dvh - 46px);
    min-height: calc(100dvh - 46px);
    background-color: #fff;
    /* 自定义滚动条样式 */
    // &::-webkit-scrollbar {
    //   width: calc(4 / 375 * 100vw);
    //   background-color: transparent;
    // }
    // &::-webkit-scrollbar-track {
    //   background: transparent;
    // }
    // &::-webkit-scrollbar-thumb {
    //   background: rgba(0, 0, 0, 0.2);
    //   border-radius: calc(2 / 375 * 100vw);
    //   transition: background 0.3s ease;
    //   &:hover {
    //     background: rgba(0, 0, 0, 0.4);
    //   }
    // }
    // /* Firefox 滚动条样式 */
    // scrollbar-width: thin;
    // scrollbar-color: rgba(0, 0, 0, 0.2) #fff;
  }

  .dealers-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: calc(12 / 375 * 100vw);
    align-items: start;
    padding-left: calc(15 / 375 * 100vw);
    padding-bottom: calc(70 / 375 * 100vw);
    background-color: #fff;
  }

  .dealer-card {
    width: calc(345 / 375 * 100vw);
    min-height: calc(168 / 375 * 100vw);
    background-color: rgba(195, 204, 214, 0.2);
    border-radius: calc(10 / 375 * 100vw);
    padding: calc(20 / 375 * 100vw) calc(16 / 375 * 100vw);
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    position: relative;
    // &:hover {
    //   background-color: rgba(195, 204, 214, 0.5);
    // }
  }

  .dealer-distance {
    position: absolute;
    top: calc(12 / 375 * 100vw);
    right: calc(8 / 375 * 100vw);
    padding: calc(4 / 375 * 100vw) calc(8 / 375 * 100vw);
    color: rgba(0, 0, 0, 0.8);
    font-size: calc(12 / 375 * 100vw);
    font-family: 'FZLanTingHeiS-R-GB';
    top: calc(20 / 375 * 100vw);
  }

  .dealer-tag {
    background-color: rgba(55, 67, 76, 0.1);
    font-size: calc(10 / 375 * 100vw);
    font-family: 'FZLanTingHeiS-DB-GB';
    padding: calc(4 / 375 * 100vw) calc(8 / 375 * 100vw);
    border-radius: calc(4 / 375 * 100vw);
    margin-bottom: calc(8 / 375 * 100vw);
  }

  .dealer-name {
    font-size: calc(16 / 375 * 100vw);
    line-height: calc(27.2 / 375 * 100vw);
    // margin-bottom: calc(14 / 375 * 100vw);
    font-family: 'FZLanTingHeiS-DB-GB';
  }

  .dealer-address {
    font-size: calc(12 / 375 * 100vw);
    padding: calc(8 / 375 * 100vw) 0;
    // line-height: calc(27.2 / 375 * 100vw);
    font-family: 'FZLanTingHeiS-R-GB';
  }

  .dealer-phone,
  .dealer-service {
    line-height: calc(25.2 / 375 * 100vw);
    font-size: calc(12 / 375 * 100vw);
    font-family: 'FZLanTingHeiS-R-GB';
    display: flex;
    align-items: center;
    width: 100%;
  }

  .phone-label {
    margin-right: calc(4 / 375 * 100vw);
    white-space: nowrap;
  }

  .phone-number {
    text-decoration: underline;
  }
}

</style>
